import styled from 'styled-components';
import { Box } from '@mui/material';import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
export const ViewCountryHeadCountWrapper = styled(Dialog)`
.customDialogTitle {
  background-color: #1b4a83;
  text-align: end;
  color: #fff;
}

.customDialog {
  text-align: left;
  color: #000;
  font-family: 'Noto Sans', sans-serif;
  padding:0px 0px 0px 0px;
  flex: 1 1 auto;
    -webkit-overflow-scrolling: touch;
    overflow-y: auto;
}
}

table {

  thead {
    background-color: rgb(27, 74, 131);
    z-index: 100;
    position: sticky;
    top: 0px;

      th {
          color: #fff;
          font-size: 14px;
          font-weight: 600;
          background-color: rgb(27, 74, 131);
          font-family: 'Noto Sans', sans-serif;
          
          }
          .addRow {
            background-color: #fff !important;
            padding:10px 10px 0px 10px;

            .newRow {
                display: flex;
                text-align: left;
                .inputdropdownBox {
                    width: 200px ;
                    min-height: 83px;

                    .customDropdown {
                        text-align: left;
                        padding-top: 10px;
                        width: 90%;
                    }
                }

                .inputBox {
                    width: 60%;
                    min-height: 66px;
                }

                .buttonTab {
                    width: 40%;
                    text-align: right;
                    font-family: 'Noto Sans', sans-serif;

                    .addbutton {
                        text-align: center;
                    }
                }

                span.error {
                    color: #d32f2f;
                    line-height: 2;
                    text-wrap: nowrap;
                    font-weight: 400;
                    font-size: 11px;
                }

                span.red {
                    color: #ff0000;
                }

                .errorInput {
                    border: 1px solid #ff0000;
                    border-radius: 5px;


                }
            }
          

      }
      .css-1qgma8u-MuiButtonBase-root-MuiTableSortLabel-root.Mui-active .MuiTableSortLabel-icon {
        opacity: 1;
        color: #fff;
    }

    .MuiTableSortLabel-icon {
        opacity: 1;
        color: #fff;
        font-size: 20px;
    }
  }

  tbody {
      tr {
          td {
              font-size: 14px;
              font-weight: 600;
              text-align: left;
              width: 50%;
              font-family: 'Noto Sans', sans-serif;


          }
      }
  }

}


.dialogbutton {
  text-align: center;
  display: block;
  font-family: 'Noto Sans', sans-serif;

  .confirmButton {
      text-align: center;
      background-color: #239155;
  }

  .rightButton {
      text-align: center;
  }
}
`;

